export function imgW(url, w) {
  if (!url || typeof url !== "string") return url;
  if (!url.includes("images.pexels.com")) return url;
  if (/([?&])w=\d+/.test(url)) return url.replace(/([?&])w=\d+/, `$1w=${w}`);
  return `${url}${url.includes("?") ? "&" : "?"}auto=compress&cs=tinysrgb&w=${w}`;
}

export function srcSet(url) {
  if (!url || !url.includes("images.pexels.com")) return undefined;
  return [400, 700, 1100].map((w) => `${imgW(url, w)} ${w}w`).join(", ");
}

export function imgFallback(e) {
  const el = e.currentTarget;
  if (el.dataset.fbk) return;
  el.dataset.fbk = "1";
  el.style.opacity = "0";
  el.parentElement?.classList.add("bg-[#F5F5F5]");
}

export const DEFAULT_IMG_T = { fit: "contain", zoom: 1, x: 0, y: 0, rot: 0 };

export function imgT(t) {
  const { fit = "contain", zoom = 1, x = 0, y = 0, rot = 0 } = t || {};
  const st = { objectFit: fit };
  if (zoom !== 1 || x || y || rot) st.transform = `translate(${x}%, ${y}%) scale(${zoom}) rotate(${rot}deg)`;
  return st;
}
